import { getStaticImageUrl } from 'client/utils/image-helpers';
import React from 'react';
import PropTypes from 'prop-types';

export function EdmundsLogoText(props) {
  const { className, width, height } = props;
  return (
    <picture>
      <img
        src={getStaticImageUrl('/images/logos/edmunds-logo-and-text-226x36-trans.png')}
        alt="edmunds logo and edmunds"
        className={className}
        width={width}
        height={height}
      />
    </picture>
  );
}

EdmundsLogoText.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

EdmundsLogoText.defaultProps = {
  className: '',
  width: 'auto',
  height: 'auto',
};
